import { LOCALES, LOCALE_NAMES, type Locale, useLocale, useSetLocale, useT } from "@/i18n";

/** Endonym options, so a teacher in the wrong language can still find their own. */
export function LocalePicker() {
  const locale = useLocale();
  const setLocale = useSetLocale();
  const t = useT();

  return (
    <select
      aria-label={t["language.label"]}
      value={locale}
      onChange={(event) => setLocale(event.target.value as Locale)}
      className="h-9 rounded-full border border-gray-200 bg-white px-3 body-sm font-semibold text-app-ink focus:outline-none focus:ring-2 focus:ring-app-aqua"
    >
      {LOCALES.map((option) => (
        <option key={option} value={option}>
          {LOCALE_NAMES[option]}
        </option>
      ))}
    </select>
  );
}
